import axios from "axios"

class BillingService {
  api
  constructor() {
    this.api = axios.create({
      baseURL: `${process.env.REACT_APP_API_URL}`,
    })
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem("Token")

      if (token) {
        config.headers = {
          Authorization: `Token ${token}`,
          withCredentials: false,
          "Content-Type": "application/json; charset=UTF-8",
        }
      }

      return config
    })
  }

  getBillingList = async () => {
    try {
      const response = await this.api.get(`/billing/`)
      return response.data
    } catch (error) {
      throw error
    }
  }

  getBillingDetails = async (billingId) => {
    try {
      const response = await this.api.get(`/billing/${billingId}/`)
      return response.data
    } catch (error) {
      throw error
    }
  }

  createBilling = async (billingData) => {
    try {
      const response = await this.api.post(`/billing/`, billingData)
      return response.data
    } catch (error) {
      throw error
    }
  }

  updateBilling = async (billingId, billingData) => {
    try {
      const response = await this.api.put(`/billing/${billingId}/`, billingData)
      return response.data
    } catch (error) {
      throw error
    }
  }

  deleteBilling = async (billingId) => {
    try {
      const response = await this.api.delete(`/billing/${billingId}/`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}

const billingService = new BillingService()

export default billingService
